export default {
    CHARGEBEE_INITIALIZED({ commit }) {
        commit('CHARGEBEE_INITIALIZED');
    },
};
